import { type DataBindingController } from '../types'

export const doesControllerHaveConnectionsToComponent = ({
  controller,
  componentId,
}: {
  controller: DataBindingController
  componentId: string
}): boolean => controller.custom.relatedConnections[componentId] !== undefined
